import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';
import store from 'app/store';

export const Index = {
    auth: authRoles.producer,
    routes: [
        {
            path: '/pickups-and-labs',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'producer_business':
                            return import('./producer-business/PickupsAndLabsProducerBusinessApp');
                        default:
                            return import('./PickupsAndLabsApp');
                    }
                },
            }),
        },
    ],
};

export default [Index];
